import { LockOutlineIcon } from './LockOutlineIcon';

/**
 * author: Google
 * id 86AD97CA-6028-45C2-8C9A-8C4A562A8E49
 * name lock-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-outline.svg
 * tags
 * - Lock 
 * - Home Automation 
 * - Automotive 
 */
export const EncryptionOutlineIcon = LockOutlineIcon;
export default EncryptionOutlineIcon